<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <div class="home">
      <h1>Welcome to Floor Plan Mapper Online</h1>
      <p><a href="/guide.pdf" target="_blank">Follow our Setup and Administration Guide</a> to get Floor Plan Mapper ready.</p>
      <p>
        Adding floors is the first task.
        <router-link :to="{ name: 'floors' }">Click here</router-link>
        to get started.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  computed: {
    ...mapGetters('rbac', ['can']),
    ...mapGetters('floor', ['floors'])
  },
  watch: {
    floors: {
      immediate: true,
      handler(floors) {
        // if we has some published floor redirect on map
        if (floors.some((floor) => floor.status === 1)) {
          this.$router.push({ name: 'map-home' })
        }
      }
    }
  }
}
</script>
